import { Box, LinearProgress, Radio, Skeleton } from "@mui/material";
import React from "react";
import GenieText from "../../../../components/core/genie-text/GenieText";
import { theme } from "../../../../components/special/genie-theme/genie-theme";
import useGetAddress from "../../../../queries/routes/useGetAddress";
import usePutAddress, {
  PutAddressBody,
} from "../../../../queries/routes/usePutAddress";
import { User } from "../../../../types/api/User";
import { Undefinable } from "../../../../utils/Nullable";
import { Cart } from "../../../../types/api/Cart";
import useAddAddressToOrder from "../../../../queries/routes/useAddAddressToOrder";

interface Props {
  org_id: Undefinable<string>;
  user: Undefinable<User>;
  cart: Cart | undefined;
}

function Addresses({ user, org_id, cart }: Props) {
  const { data: addresses } = useGetAddress(user?.organizations[0].id!);
  const { mutate: addAddress } = usePutAddress(user?.organizations[0].id!);

  const { mutate: addAddressToOrder, isLoading } = useAddAddressToOrder(
    cart?.id,
    org_id!,
    user?.organizations[0].id!
  );

  const updateAddress = (address: PutAddressBody) => {
    if (cart?.order && address && address.address.id) {
      addAddressToOrder({
        orderId: cart.order?.id,
        addressId: address.address.id,
      });
    }

    addAddress({
      ...address,
      is_default_shipping: true,
    });
  };

  if (!org_id || !user) {
    return null;
  }

  return (
    <Box mt={2}>
      {isLoading ? (
        <LinearProgress sx={{ mb: 1 }} />
      ) : (
        <Box height={"4px"} mb={1} />
      )}
      <Box
        display={"grid"}
        sx={{
          rowGap: 4,
          columnGap: 2,
          gridTemplateColumns: "1fr 1fr 1fr",
          mb: 2,
          [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr 1fr",
          },
        }}
        borderBottom={"1px solid"}
        borderColor={"divider"}
        pb={2}
      >
        {addresses ? (
          addresses.map((item) => (
            <Box
              key={item.address.id}
              display={"inline-block"}
              border={"1px solid"}
              padding={1}
              borderRadius={1}
              borderColor={"divider"}
            >
              <Radio
                sx={{ ml: -1, mt: -1 }}
                size="small"
                checked={item.address.id === cart?.order?.shipping_address?.id}
                name="radio-buttons"
                inputProps={{ "aria-label": "A" }}
                onClick={() => updateAddress(item)}
              />
              <GenieText fontSize={"tiny"}>{item.address.line1}</GenieText>
              <GenieText fontSize={"tiny"}>{item.address.line2}</GenieText>
              <GenieText fontSize={"tiny"}>
                {item.address.city}, {item.address.state}{" "}
                {item.address.postal_code}
              </GenieText>
            </Box>
          ))
        ) : (
          <>
            <Skeleton height={150} />
            <Skeleton height={150} />
          </>
        )}
      </Box>
    </Box>
  );
}

export default Addresses;
